import apiClient from '@/core/api/';

//constants
const baseApiURL = 'api/code';

export const getRegions = async () =>
  await apiClient.get(`${baseApiURL}/regions`);

export const getMunicipalities = async () =>
  await apiClient.get(`${baseApiURL}/municipalities`);

export const getMunicipalitiesByRegionId = async (regionId) =>
  await apiClient.get(`${baseApiURL}/municipalitiesbyregion/${regionId}`);

export const getSchools = async () =>
  await apiClient.get(`${baseApiURL}/schools`);

export const getSchoolsByMunicipalityId = async (municipalityId) =>
  await apiClient.get(`${baseApiURL}/schoolsbymunicipality/${municipalityId}`);

export const getUniversities = async () =>
  await apiClient.get(`${baseApiURL}/universities`);

export const getAttachmentCategories = async () =>
  await apiClient.get(`${baseApiURL}/attachmentcategories`);
